import { render, staticRenderFns } from "./soc-eco@.vue?vue&type=template&id=12ff12dd&"
import script from "./soc-eco@.vue?vue&type=script&lang=ts&"
export * from "./soc-eco@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports